export function initializeLightbox() {
    const galleryItems = document.querySelectorAll('.gallery-item img');

    if (!galleryItems.length) {
        return;
    }

    const lightbox = createLightboxElements();
    document.body.appendChild(lightbox.container);

    let triggerElement = null;

    galleryItems.forEach((img, index) => {
        img.addEventListener('click', (e) => {
            e.preventDefault();
            triggerElement = img;
            openLightbox(index, galleryItems, lightbox);
        });
        img.style.cursor = 'pointer';
    });

    lightbox.closeBtn.addEventListener('click', () => closeLightbox(lightbox, triggerElement));
    lightbox.overlay.addEventListener('click', (e) => {
        if (e.target === lightbox.overlay) {
            closeLightbox(lightbox, triggerElement);
        }
    });

    lightbox.prevBtn.addEventListener('click', () => {
        const currentIndex = parseInt(lightbox.container.dataset.currentIndex);
        const newIndex = currentIndex > 0 ? currentIndex - 1 : galleryItems.length - 1;
        showImage(newIndex, galleryItems, lightbox);
    });

    lightbox.nextBtn.addEventListener('click', () => {
        const currentIndex = parseInt(lightbox.container.dataset.currentIndex);
        const newIndex = currentIndex < galleryItems.length - 1 ? currentIndex + 1 : 0;
        showImage(newIndex, galleryItems, lightbox);
    });

    document.addEventListener('keydown', (e) => {
        if (!lightbox.container.classList.contains('active')) {
            return;
        }

        const currentIndex = parseInt(lightbox.container.dataset.currentIndex);

        switch(e.key) {
            case 'Escape':
                closeLightbox(lightbox, triggerElement);
                break;
            case 'ArrowLeft':
                e.preventDefault();
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : galleryItems.length - 1;
                showImage(prevIndex, galleryItems, lightbox);
                break;
            case 'ArrowRight':
                e.preventDefault();
                const nextIndex = currentIndex < galleryItems.length - 1 ? currentIndex + 1 : 0;
                showImage(nextIndex, galleryItems, lightbox);
                break;
            case 'Tab':
                trapFocus(e, lightbox);
                break;
        }
    });
}

function createLightboxElements() {
    const container = document.createElement('div');
    container.className = 'lightbox';
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-label', 'Image lightbox');
    container.setAttribute('aria-modal', 'true');

    const overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    const modal = document.createElement('div');
    modal.className = 'lightbox-modal';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'lightbox-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.setAttribute('aria-label', 'Close lightbox');

    const imageContainer = document.createElement('div');
    imageContainer.className = 'lightbox-image-container';

    const image = document.createElement('img');
    image.className = 'lightbox-image';
    image.setAttribute('alt', '');

    const prevBtn = document.createElement('button');
    prevBtn.className = 'lightbox-nav lightbox-prev';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.setAttribute('aria-label', 'Previous image');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'lightbox-nav lightbox-next';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.setAttribute('aria-label', 'Next image');

    const counter = document.createElement('div');
    counter.className = 'lightbox-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');

    imageContainer.appendChild(image);
    modal.appendChild(closeBtn);
    modal.appendChild(imageContainer);
    modal.appendChild(prevBtn);
    modal.appendChild(nextBtn);
    modal.appendChild(counter);
    container.appendChild(overlay);
    container.appendChild(modal);

    return {
        container,
        overlay,
        modal,
        closeBtn,
        image,
        prevBtn,
        nextBtn,
        counter
    };
}

function openLightbox(index, galleryItems, lightbox) {
    lightbox.container.classList.add('active');
    lightbox.container.dataset.currentIndex = index;
    document.body.style.overflow = 'hidden';

    showImage(index, galleryItems, lightbox);
    lightbox.closeBtn.focus();
}

function closeLightbox(lightbox, triggerElement) {
    lightbox.container.classList.remove('active');
    document.body.style.overflow = '';

    if (triggerElement) {
        triggerElement.focus();
    }
}

function showImage(index, galleryItems, lightbox) {
    const img = galleryItems[index];
    const src = img.src;
    const alt = img.alt;

    lightbox.image.src = src;
    lightbox.image.alt = alt;
    lightbox.container.dataset.currentIndex = index;
    lightbox.counter.textContent = `${index + 1} / ${galleryItems.length}`;

    preloadAdjacentImages(index, galleryItems);
}

function trapFocus(e, lightbox) {
    const focusableElements = lightbox.container.querySelectorAll(
        'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
    );

    if (!focusableElements.length) {
        return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
        if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
        }
    } else {
        if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
        }
    }
}

function preloadAdjacentImages(currentIndex, galleryItems) {
    const preloadIndexes = [
        currentIndex > 0 ? currentIndex - 1 : galleryItems.length - 1,
        currentIndex < galleryItems.length - 1 ? currentIndex + 1 : 0
    ];

    preloadIndexes.forEach(index => {
        const img = new Image();
        img.src = galleryItems[index].src;
    });
}
